var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    fill: "url(#paint0_linear_961_55085)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    stroke: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_961_55085)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_961_55085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0734 28H15.8224C15.2528 28 14.7222 27.7123 14.4099 27.2352L12.2774 23.9721C11.5444 22.8502 12.3497 21.3625 13.6899 21.3625H26.2059C27.5461 21.3625 28.3514 22.8502 27.6184 23.9721L25.4859 27.2352C25.1736 27.7123 24.643 28 24.0734 28Z",
    fill: "url(#paint1_linear_961_55085)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_961_55085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9789 25.2779C26.6424 23.5418 25.1143 22.2316 23.2791 22.2316C21.4439 22.2316 19.9159 23.5418 19.5793 25.2779C19.5064 25.6525 19.8026 26 20.1838 26H26.3734C26.7557 26 27.0508 25.6536 26.9778 25.2779H26.9789Z",
    fill: "url(#paint2_linear_961_55085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.279 21.3461C24.3124 21.3461 25.1501 20.5084 25.1501 19.475C25.1501 18.4416 24.3124 17.6038 23.279 17.6038C22.2456 17.6038 21.4078 18.4416 21.4078 19.475C21.4078 20.5084 22.2456 21.3461 23.279 21.3461Z",
    fill: "url(#paint3_linear_961_55085)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.4107 20.6741C24.0742 18.938 22.5461 17.6277 20.7109 17.6277C18.8757 17.6277 17.3477 18.938 17.0111 20.6741C16.9381 21.0487 17.2344 21.3962 17.6156 21.3962H23.8051C24.1874 21.3962 24.4826 21.0498 24.4096 20.6741H24.4107Z",
    fill: "url(#paint4_linear_961_55085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7107 16.7423C21.7441 16.7423 22.5819 15.9045 22.5819 14.8711C22.5819 13.8377 21.7441 13 20.7107 13C19.6773 13 18.8396 13.8377 18.8396 14.8711C18.8396 15.9045 19.6773 16.7423 20.7107 16.7423Z",
    fill: "url(#paint5_linear_961_55085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2912 25.0949C18.8686 22.9188 16.9528 21.2753 14.6526 21.2753C12.3523 21.2753 10.4365 22.9188 10.014 25.0949C9.92247 25.5654 10.2928 25.9999 10.772 25.9999H18.5321C19.0113 25.9999 19.3816 25.5654 19.2901 25.0949H19.2912Z",
    fill: "url(#paint6_linear_961_55085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8463 25.2474C30.4894 23.438 28.8716 22.0714 26.929 22.0714C24.9865 22.0714 23.3687 23.438 23.0118 25.2474C22.9345 25.6386 23.2472 26 23.6519 26H30.2052C30.6099 26 30.9226 25.6386 30.8454 25.2474H30.8463Z",
    fill: "url(#paint7_linear_961_55085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1897 20.103C16.4501 19.8055 17.2307 18.5426 16.9333 17.2822C16.6358 16.0217 15.3728 15.2411 14.1124 15.5386C12.852 15.8361 12.0714 17.099 12.3688 18.3595C12.6663 19.6199 13.9293 20.4005 15.1897 20.103Z",
    fill: "url(#paint8_linear_961_55085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3821 21.0202C28.4465 20.769 29.1057 19.7025 28.8545 18.6381C28.6032 17.5737 27.5367 16.9145 26.4724 17.1657C25.408 17.417 24.7488 18.4835 25 19.5479C25.2512 20.6122 26.3177 21.2714 27.3821 21.0202Z",
    fill: "url(#paint9_linear_961_55085)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_961_55085",
    x: -81,
    y: -71.6375,
    width: 201.896,
    height: 192.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 46.5,
    result: "effect1_foregroundBlur_961_55085"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_961_55085",
    x: -73.4318,
    y: -75.3962,
    width: 193.421,
    height: 194.396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 46.5,
    result: "effect1_foregroundBlur_961_55085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_961_55085",
    x1: 18.0556,
    y1: 21.1111,
    x2: 6.94445,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C441F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_961_55085",
    x1: 12.0012,
    y1: 24.6805,
    x2: 27.896,
    y2: 24.6805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A055FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CF19A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_961_55085",
    x1: 23.2791,
    y1: 28.0737,
    x2: 23.2791,
    y2: 16.7434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_961_55085",
    x1: 23.279,
    y1: -31.5434,
    x2: 23.279,
    y2: 16.7434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_961_55085",
    x1: 20.7104,
    y1: 13.8593,
    x2: 20.7104,
    y2: 25.1646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_961_55085",
    x1: 20.7107,
    y1: 9.25773,
    x2: 20.7107,
    y2: 20.4845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_961_55085",
    x1: 14.652,
    y1: 16.5506,
    x2: 14.652,
    y2: 30.7246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_961_55085",
    x1: 26.9286,
    y1: 18.1428,
    x2: 26.9286,
    y2: 29.9286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_961_55085",
    x1: 13.0351,
    y1: 10.9742,
    x2: 16.267,
    y2: 24.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_961_55085",
    x1: 25.5626,
    y1: 13.3112,
    x2: 28.2918,
    y2: 24.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_961_55085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.8fa8e1c2e9f3a5ffb07a8f3af4e6b6fd.svg";
export { ForwardRef as ReactComponent };